import EndpointsBase from '../base';

enum EndpointsDocumentCollection {
  DocumentCollectionList = EndpointsBase.BaseDocumentCollection,
  DocumentCollectionDetail = `${EndpointsBase.BaseDocumentCollection}/:id`,
}

export default EndpointsDocumentCollection;
